import React, { useState, useEffect } from "react";

const statesAndCities = {
  Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane"],
  Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
  Karnataka: ["Bengaluru", "Mysuru", "Hubli", "Mangalore", "Belgaum"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Salem", "Tiruchirapalli"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Agra", "Noida"],
  Delhi: ["New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh"],
  Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer"],
  "West Bengal": ["Kolkata", "Howrah", "Asansol", "Siliguri", "Durgapur"],
  Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Mohali"],
  Bihar: ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia"],
  "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Tirupati",
  ],
  Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
  Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Kollam", "Thrissur"],
  Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Puri", "Sambalpur"],
};

const reviewOptions = [
  { label: "4.5 and above", value: "4.5+" },
  { label: "4.0 to 4.5", value: "4.0-4.5" },
  { label: "3.5 to 4.0", value: "3.5-4.0" },
  { label: "3.0 to 3.5", value: "3.0-3.5" },
  { label: "Below 3.0", value: "<3.0" },
];

const sortOptions = [
  { label: "Price: Low to High", value: "price-asc" },
  { label: "Price: High to Low", value: "price-desc" },
  { label: "Rating: High to Low", value: "rating-desc" },
  { label: "Newest", value: "newest" },
];

const FilterSidebar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const params = new URLSearchParams(window.location.search);

  // Area filter states
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedArea, setSelectedArea] = useState("");

  const [availableAreas, setAvailableAreas] = useState([]);

  // Multiple selected areas as tags (state/city/area combined string)
  const [selectedAreas, setSelectedAreas] = useState([]);

  // Price range
  const [priceRange, setPriceRange] = useState([0, 1000]); // min 0, max 1000

  // Reviews
  const [selectedReview, setSelectedReview] = useState("");

  // Sort
  const [selectedSort, setSelectedSort] = useState("");

  // Update cities when state changes
  // useEffect(() => {
  //   if (selectedState && STATES[selectedState]) {
  //     setAvailableCities(Object.keys(STATES[selectedState].cities));
  //     setSelectedCity("");
  //     setAvailableAreas([]);
  //     setSelectedArea("");
  //   } else {
  //     setAvailableCities([]);
  //     setAvailableAreas([]);
  //     setSelectedCity("");
  //     setSelectedArea("");
  //   }
  // }, [selectedState]);

  // Update areas when city changes
  // useEffect(() => {
  //   if (selectedState && selectedCity) {
  //     // setAvailableAreas(STATES[selectedState].cities[selectedCity]);
  //     setSelectedArea("");
  //   } else {
  //     setAvailableAreas([]);
  //     setSelectedArea("");
  //   }
  // }, [selectedCity, selectedState]);

  const availableCities = selectedState
    ? statesAndCities[selectedState] || []
    : [];

  // Add area tag
  function addArea() {
    // if (!selectedState || !selectedCity || !selectedArea) return;

    // const areaTag = `${selectedState} / ${selectedCity} / ${selectedArea}`;
    // if (!selectedAreas.includes(areaTag)) {
    //   setSelectedAreas((prev) => [...prev, areaTag]);
    // }

    params.set("state", selectedState);
    params.set("city", selectedCity);
    window.location = `?${params.toString()}`;
  }

  // Remove area tag
  function removeArea(areaTag) {
    setSelectedAreas((prev) => prev.filter((a) => a !== areaTag));
  }

  // Handle price range input change
  function handlePriceInputChange(e, index) {
    const value = Number(e.target.value);
    if (isNaN(value)) return;
    let newRange = [...priceRange];
    newRange[index] = value;

    // Keep min <= max
    if (index === 0 && value > priceRange[1]) return;
    if (index === 1 && value < priceRange[0]) return;

    setPriceRange(newRange);
  }

  // Handle price range slider change
  function handlePriceRangeChange(e) {
    const value = Number(e.target.value);
    const name = e.target.name;
    let newRange = [...priceRange];
    if (name === "min") {
      if (value <= priceRange[1]) {
        newRange[0] = value;
      }
    } else {
      if (value >= priceRange[0]) {
        newRange[1] = value;
      }
    }
    setPriceRange(newRange);
  }

  // useEffect(() => {
  //   if (searchTerm !== "") {
  //     const dbounce = setTimeout(() => {
  //       params.set("search", searchTerm);
  //       window.location = `?${params.toString()}`;
  //     }, 300);

  //     return () => clearTimeout(dbounce);
  //   }
  // }, [searchTerm]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const search = params.get("search") || "";
    const state = params.get("state") || "";
    const city = params.get("city") || "";

    setSearchTerm(search);
    setSelectedState(state);
    setSelectedCity(city);
  }, [window.location.search]);

  return (
    <>
      <style>{`
        .sidebar {
          // width: 320px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
          padding: 24px;
          font-family: "Josefin Sans", serif;
          color: #333;
        }
        .section {
          margin-bottom: 24px;
        }
        .section h3 {
          font-family: "Josefin Sans", serif;
        text-align:left;
          font-size: 1.25rem;
          margin-bottom: 12px;
          border-bottom: 2px solid #800000;
          padding-bottom: 6px;
          color: #800000;
        }
        .search-input {
          width: 100%;
          position: relative;
        }
        .search-input input {
          width: 100%;
          padding: 10px 40px 10px 12px;
          border: 1.5px solid #cbd5e1;
          border-radius: 8px;
          font-size: 1rem;
          transition: border-color 0.2s;
        }
        .search-input input:focus {
          outline: none;
          border-color: #800000;
          box-shadow: 0 0 5px #800000;
        }
        .search-input svg {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          width: 20px;
          height: 20px;
          fill: #800000;
        }
        select, input[type="number"] {
          width: 100%;
          padding: 8px 12px;
          margin-top: 8px;
          margin-bottom: 12px;
          border: 1.5px solid #cbd5e1;
          border-radius: 8px;
          font-size: 1rem;
          appearance: none;
          background: url("data:image/svg+xml,%3csvg fill='none' stroke='%236B7280' stroke-width='2' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'%3e%3c/path%3e%3c/svg%3e") no-repeat right 12px center / 16px 16px;
          background-color: white;
          cursor: pointer;
        }
        .tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 8px;
        }
        .tag {
          background: #e0e7ff;
          color: #800000;
          padding: 4px 10px;
          border-radius: 9999px;
          font-size: 0.85rem;
          display: flex;
          align-items: center;
          gap: 6px;
          user-select: none;
        }
        .tag button {
          background: transparent;
          border: none;
          color: #800000;
          font-weight: bold;
          cursor: pointer;
          font-size: 1rem;
          line-height: 1;
        }
        .btn-add-area {
          background: #800000;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s;
          width: 100%;
        }
        .btn-add-area:hover:not(:disabled) {
          background:#800000;
        }
        .btn-add-area:disabled {
          background: var(--primaryColor);
          cursor: not-allowed;
        }
        .price-range-inputs {
          display: flex;
          gap: 8px;
          margin-bottom: 8px;
        }
        .price-range-inputs input[type="number"] {
          width: 50%;
        }
        .range-slider {
          display: flex;
          justify-content: space-between;
          gap: 12px;
        }
        .range-slider input[type="range"] {
          -webkit-appearance: none;
          width: 50%;
          height: 6px;
          background: #ddd;
          border-radius: 3px;
          outline: none;
          cursor: pointer;
        }
        .range-slider input[type="range"]::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 18px;
          height: 18px;
          background: #800000;
          cursor: pointer;
          border-radius: 50%;
          border: none;
          margin-top: -6px;
          transition: background 0.3s;
        }
        .range-slider input[type="range"]:focus::-webkit-slider-thumb {
          background: #4338ca;
        }
        .radio-group {
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .radio-label {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 1rem;
          cursor: pointer;
          user-select: none;
        }
        .radio-label input[type="radio"] {
          accent-color: #800000;
          cursor: pointer;
          width: 18px;
          height: 18px;
        }
      `}</style>

      <aside className="sidebar" aria-label="Filter sidebar">
        {/* Search */}
        <div className="section">
          <h3>Search</h3>
          <div className="search-input">
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search"
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  const params = new URLSearchParams(window.location.search);
                  params.set("search", searchTerm);
                  window.location = `?${params.toString()}`;
                }
              }}
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                stroke="none"
                d="M21 21l-4.35-4.35m2.15-5.15a7 7 0 1 1-14 0 7 7 0 0 1 14 0z"
                fill="none"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                // stroke="#800000"
              />
            </svg>
          </div>
        </div>

        {/* Filter by Area */}
        <div className="section" aria-label="Filter by Area">
          <h3>Filter by Area</h3>
          <select
            value={selectedState}
            onChange={(e) => {
              setSelectedState(e.target.value);
              setSelectedCity(""); // Reset city on state change
            }}
            aria-label="Select State"
          >
            <option value="">Select State</option>
            {Object.keys(statesAndCities).map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>

          {/* City Dropdown */}
          <select
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            aria-label="Select City"
            disabled={!availableCities.length}
          >
            <option value="">Select City</option>
            {availableCities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </select>

          {/* <select
            value={selectedArea}
            onChange={(e) => setSelectedArea(e.target.value)}
            aria-label="Select Area"
            disabled={!availableAreas.length}
          >
            <option value="">Select Area</option>
            {availableAreas.map((area) => (
              <option key={area} value={area}>
                {area}
              </option>
            ))}
          </select> */}

          <button
            className="btn-add-area"
            onClick={addArea}
            disabled={!selectedState || !selectedCity}
            aria-disabled={!selectedState || !selectedCity}
            aria-label="Add selected area"
          >
            Search Location
          </button>

          {/* <div className="tags" aria-live="polite">
            {selectedAreas.map((areaTag) => (
              <div key={areaTag} className="tag">
                {areaTag}
                <button
                  onClick={() => removeArea(areaTag)}
                  aria-label={`Remove area ${areaTag}`}
                >
                  ×
                </button>
              </div>
            ))}
          </div> */}
        </div>

        {/* Price Range */}
        {/* <div className="section" aria-label="Filter by Price Range">
          <h3>Price Range</h3>

          <div className="price-range-inputs">
            <input
              type="number"
              min={0}
              max={priceRange[1]}
              value={priceRange[0]}
              onChange={(e) => handlePriceInputChange(e, 0)}
              aria-label="Minimum price"
            />
            <input
              type="number"
              min={priceRange[0]}
              max={1000}
              value={priceRange[1]}
              onChange={(e) => handlePriceInputChange(e, 1)}
              aria-label="Maximum price"
            />
          </div>

          <div className="range-slider">
            <input
              type="range"
              name="min"
              min={0}
              max={1000}
              value={priceRange[0]}
              onChange={handlePriceRangeChange}
              aria-label="Minimum price range slider"
            />
            <input
              type="range"
              name="max"
              min={0}
              max={1000}
              value={priceRange[1]}
              onChange={handlePriceRangeChange}
              aria-label="Maximum price range slider"
            />
          </div>
        </div> */}

        {/* Filter by Reviews */}
        {/* <div className="section" aria-label="Filter by Reviews">
          <h3>Filter by Reviews</h3>
          <div className="radio-group">
            {reviewOptions.map(({ label, value }) => (
              <label key={value} className="radio-label">
                <input
                  type="radio"
                  name="reviews"
                  value={value}
                  checked={selectedReview === value}
                  onChange={() => setSelectedReview(value)}
                />
                {label}
              </label>
            ))}
          </div>
        </div> */}

        {/* Sort By */}
        {/* <div className="section" aria-label="Sort By">
          <h3>Sort By</h3>
          <div className="radio-group">
            {sortOptions.map(({ label, value }) => (
              <label key={value} className="radio-label">
                <input
                  type="radio"
                  name="sort"
                  value={value}
                  checked={selectedSort === value}
                  onChange={() => setSelectedSort(value)}
                />
                {label}
              </label>
            ))}
          </div>
        </div> */}
      </aside>
    </>
  );
};

export default FilterSidebar;
